<template>

    <div class="index background">

        <div class="about-content">

            <div class="serve-title bold">用户协议</div>

            <div class="serve-text" v-html="html"></div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
export default {
    name: "user",
    mixins: [mixin]
}
</script>

<style scoped src="./style.css"></style>
